
export const setDialogSection = ({ commit }, value) => {
    commit("SET_DIALOG_SECTION", value);
};